module.exports = "/_next/static/images/main-visual-shopping@2x-bac48777338c2960299e8bb1fd576433.jpg";